import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const SVG = styled.svg`
    cursor: pointer;
    width: 100%;
    height: 100%;

    rect {
        fill: #FFF;
        transition: all 300ms ease-in-out;
        transform-origin: 25% 50%;
    }

    path {
      fill: #FFF;
  }

  &.is-open .bar1 {
    transform: rotate(45deg);
  }

  &.is-open .bar2 {
      transform: translateX(-100%);
      opacity: 0;
  }

  &.is-open .bar3 {
      transform: rotate(-45deg);
  }
`

function HamburgerIcon (props) {
  const { onClick, className } = props
  return (
    <SVG onClick={onClick} className={className}>
      <g className="icon">
        <rect className="bar1" height="3px" width="24px" x="0" y="4" rx="1" ry="1" />
        <rect className="bar2" height="3px" width="24px" x="0" y="10" rx="1" ry="1" />
        <rect className="bar3" height="3px" width="24px" x="0" y="16" rx="1" ry="1" />
      </g>
    </SVG>
  )
}

HamburgerIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
}

export default HamburgerIcon



// WEBPACK FOOTER //
// ./src/images/icons/Hamburger.js